/**
 * Where focus goes when the thing that had it is gone: the row archived from
 * a list, or the toast's Undo. Without this it falls to the page body and a
 * keyboard user starts again from the top. The list's current tab, else the
 * page heading.
 */
export function refocus() {
  requestAnimationFrame(() => {
    const at = document.activeElement;
    if (at && at !== document.body && at.isConnected) return;
    const target =
      document.querySelector<HTMLElement>('main [role="tab"][aria-selected="true"]') ??
      document.querySelector<HTMLElement>("main h1");
    if (!target) return;
    if (!target.hasAttribute("tabindex") && target.tagName === "H1") target.tabIndex = -1;
    target.focus();
  });
}
